import React from 'react';
import PropTypes from 'prop-types';
import {Space} from 'antd';
import {
  StyledHistory, StyledHistoryItem, StyledHistoryItemDetailsSpace, StyledHistoryItemSpace,
  StyledHistoryItemIcon, StyledHistoryItemLine
} from './StyledHistory';

const History = ({
  data = [],
  ...rest
}) => {

  return (
    <StyledHistory {...rest}>
      {data.map(({key, date, message, ...rest}, index) => (
        <StyledHistoryItem key={key || index} {...rest}>
          <StyledHistoryItemSpace
            align='start'
            size='middle'
          >
            <Space
              size={6}
              direction='vertical'
            >
              <StyledHistoryItemIcon />
              <StyledHistoryItemLine />
            </Space>
            <StyledHistoryItemDetailsSpace direction='vertical'>
              {date && (
                <span className='date'>
                  {date}
                </span>
              )}
              {message && (
                <div className='message'>
                  {message}
                </div>
              )}
            </StyledHistoryItemDetailsSpace>
          </StyledHistoryItemSpace>
        </StyledHistoryItem>
      ))}
    </StyledHistory>
  );
}

History.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      message: PropTypes.any
    })
  )
}

export default History;
